// extracted by mini-css-extract-plugin
module.exports = {"text1":"OverviewChart_text1__O6_tz","text2":"OverviewChart_text2__5lW5j"};